import {swiperInit} from './swiperInit';

export const newsListSwiper = (() => {
  swiperInit({
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    selector: '.newsListSwiper',
  })
})();
